import { useState, useEffect } from 'react'
import { getTypesAPI } from '../services/type'

function UseEmpsTypes(onlyId = []) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getTypesAPI(onlyId)
      if (!resp) return
      if (resp.status) {
        const newData = resp?.result.map((d) => ({
          value: d?.id,
          label: d?.type
        }))
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [JSON.stringify(onlyId)])

  return data
}

export default UseEmpsTypes